import type { Skill } from 'bundles/browse-common/types/Skill';

export function toSkillUrl(skill: Skill) {
  return `/courses?query=${encodeURIComponent(skill.skillName.toLowerCase())}`;
}

// We exclude skills that have <= 4 related courses.
const excludedSkills = [
  'accident-reporting',
  'adjudication',
  'adobe-acrobat',
  'adobe-analytics',
  'adobe-experience-manager',
  'advertising-mail',
  'apple-service-certification',
  'arterial-blood-gas-analysis',
  'artifactory',
  'as-built-drawings',
  'atlassian-bamboo',
  'autocad-civil-3d',
  'automated-clearing-house',
  'balancing-ledger/billing',
  'bartending',
  'basic-life-support-bls-certification',
  'bed-management',
  'behavioral-health-case-management',
  'blood-banking',
  'blueprinting',
  'breakage-control',
  'business-objects-framework',
  'business-support-systems',
  'capillary',
  'cardiac-catheterization',
  'cardiac-stress-testing',
  'cardiac-surgery',
  'cash-control',
  'cash-handling',
  'cash-receipts',
  'cashiering',
  'cavity-prevention',
  'cesarean-section',
  'chest-physiotherapy',
  'choral-music',
  'clinical-research-coordination',
  'clinical-social-work',
  'clinical-trial-management-systems',
  'common-core-standards',
  'companionship',
  'computer-aided-three-dimensional-interactive-application-catia',
  'computerized-physician-order-entry',
  'contract-accounting',
  'cpt-coding',
  'dayforce-hcm-software',
  'defibrillation',
  'dental-experience',
  'dental-informatics',
  'dental-radiography',
  'diagnostic-medical-sonography',
  'diatetics',
  'discharge-planning',
  'dispatching',
  'echocardiography',
  'eight-disciplines-problem-solving-8d',
  'electronic-benefits-transfer',
  'emergency-nursing',
  'engineering-change-order',
  'epic-emr',
  'fall-protection',
  'family-and-medical-leave-act-of-1993',
  'family-medicine',
  'federal-information-security-management-act',
  'fluoroscopy',
  'force-dot-com',
  'friendliness',
  'general-lending',
  'good-driving-record',
  'hazardous-waste-operations-and-emergency-response-standard-hazwoper',
  'home-health-care-and-assisted-living',
  'hotel-and-restaurant-management',
  'insurance-and-warranty-claims-processing',
  'interrogatories',
  'interventional-radiology',
  'inventory-staging',
  'invision-design-software',
  'iso-13485-standard',
  'it-general-controls-itgc',
  'iwork',
  'jury-trial',
  'knowledge-of-apple-hardware',
  'knowledge-of-apple-software',
  'labview',
  'law-practice-management-software',
  'legal-depositions',
  'legal-pleadings',
  'legal-support',
  'life-support',
  'lifting-ability',
  'loan-documentation',
  'loan-origination',
  'loss-prevention',
  'mammography',
  'medical-assistance',
  'medical-social-work',
  'medical-support',
  'medical-telemetry',
  'merchandise-maintenance',
  'microstrategy',
  'midwifery',
  'motion-arguments',
  'okta',
  'operational-data-store',
  'operations-support-systems',
  'oral-cancer-screening',
  'oral-motor-skills',
  'order-entry',
  'other-mobile-programming-languages',
  'patient-coordination',
  'patient-transfer-equipment',
  'pediatric-first-aid',
  'perl-programming-language',
  'personal-injury-law',
  'pharmacy-experience',
  'phlebotomy',
  'positive-airway-pressure-cpap-bipap',
  'post-anesthesia-care-unit',
  'practice-management-software',
  'pre-anesthetic-assessment',
  'procurement-cards',
  'product-family-engineering',
  'product-flow-diagram',
  'property-inspection',
  'pulmonary-function-testing',
  'punch-work',
  'recruitment-process-outsourcing',
  'regulatory-documents',
  'resource-consumption-accounting',
  'salesforce-object-query-language-soql',
  'sap-analytics-cloud',
  'sap-signavio',
  'securities-sales',
  'shop-drawing',
  'specimen-labeling',
  'speech-therapy',
  'splinting',
  'sql-server-reporting-services',
  'stock-rotation',
  'submittals-construction',
  'supplier-quality-management',
  'swallowing-disorders',
  'telemarketing',
  'tenacity',
  'trial-preparation',
  'ultipro-hris-software',
  'urgent-care',
  'venipuncture',
  'visualforce',
  'westlaw',
];

export function isNotExcludedSkill(skillId: string) {
  return !excludedSkills.includes(skillId);
}
